import { createFeature, createReducer, on } from '@ngrx/store';
import * as LoginActions from './actions';
import { User } from '../../../types/interfaces/user';

export interface State {
  loading: boolean;
  user: User | undefined;
}

export const initialState: State = {
  loading: false,
  user: undefined,
};

export const loginFeature = createFeature({
  name: 'login',
  reducer: createReducer(
    initialState,
    on(LoginActions.login, (state, action) => ({
      ...state,
      loading: true,
      user: undefined,
    })),
    on(LoginActions.loginSuccess, (state, action) => ({
      ...state,
      loading: false,
      user: action.user,
    })),
    on(LoginActions.loginError, (state) => ({
      ...state,
      loading: false,
      user: undefined,
    }))
  ),
});
